import type { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  List,
  ListItem,
  Container,
  Box,
  Link,
  Typography,
  useTheme,
} from '@mui/material';

const TermsOfUse = (): ReactElement => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Container
      maxWidth="lg"
      sx={{
        paddingTop: theme.spacing(6),
      }}
      data-testid="container"
    >
      <Box
        sx={{
          marginBottom: theme.spacing(5),
        }}
      >
        <Typography variant="h2" align="center">
          {t('legal:terms:title')}
        </Typography>
      </Box>

      <Box
        sx={{
          marginBottom: theme.spacing(6),
        }}
      >
        <Typography variant="body1">{t('legal:terms:subtitle')}</Typography>
      </Box>

      <Box
        sx={{
          '& > *': {
            marginBottom: theme.spacing(3),
          },
        }}
      >
        <Typography variant="h4">
          {t('legal:terms:sections:1:title')}
        </Typography>
        <Typography variant="body1">
          <Trans i18nKey="legal:terms:sections:1:paragraphs:1">
            <Link href="https://www.loudlysoundtracks.com">
              www.loudlysoundtracks.com
            </Link>
            <Link href="https://www.loudly.com/soundtracks">
              www.loudly.com/soundtracks
            </Link>
          </Trans>
        </Typography>

        <Typography variant="body1">
          <Trans i18nKey="legal:terms:sections:1:paragraphs:2">
            <Link href="mailto:help@loudly.com">help@loudly.com</Link>
          </Trans>
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:1:paragraphs:3')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:1:paragraphs:4')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:1:paragraphs:5')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:2:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:2:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          <Trans i18nKey="legal:terms:sections:2:paragraphs:2">
            <Link href="mailto:help@loudly.com">help@loudly.com</Link>
          </Trans>
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:2:paragraphs:3')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:2:paragraphs:4')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:2:paragraphs:5')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:2:paragraphs:6')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:3:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:3:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:3:paragraphs:2')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:3:paragraphs:3')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:3:paragraphs:4')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:4:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:4:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:4:paragraphs:2')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:5:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:5:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:5:paragraphs:2')}
        </Typography>
        <Typography variant="body1">
          <Trans i18nKey="legal:terms:sections:5:paragraphs:3">
            <Link href="mailto:help@loudly.com">help@loudly.com</Link>
            <Link href="mailto:help@loudly.com">help@loudly.com</Link>
          </Trans>
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:6:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:6:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:6:paragraphs:2')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:6:paragraphs:3')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:6:paragraphs:4')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:7:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:7:paragraphs:1')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:8:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:8:paragraphs:1')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:9:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:9:paragraphs:1')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:10:title')}
        </Typography>
        <Typography variant="body1">
          <Trans i18nKey="legal:terms:sections:10:paragraphs:1">
            <Link href="https://www.loudlysoundtracks.com">
              www.loudlysoundtracks.com
            </Link>
            <Link href="mailto:help@loudly.com">help@loudly.com</Link>
          </Trans>
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:11:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:11:paragraphs:1')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:12:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:12:paragraphs:1')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:13:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:13:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:13:paragraphs:2')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:13:paragraphs:3')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:13:paragraphs:4')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:13:paragraphs:5')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:14:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:14:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:14:paragraphs:2')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:15:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:15:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:15:paragraphs:2')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:16:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:16:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:16:paragraphs:2')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:17:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:17:paragraphs:1')}
        </Typography>

        <Typography variant="h4">
          {t('legal:terms:sections:18:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:terms:sections:18:paragraphs:1')}
        </Typography>
        <List
          sx={{
            listStyle: 'none',
            paddingLeft: 0,
          }}
        >
          <ListItem>
            <Typography variant="body1">
              {t('legal:terms:sections:18:paragraphs:2')}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="body1">
              <Trans i18nKey="legal:terms:sections:18:paragraphs:3">
                <Link href="mailto:help@loudly.com">help@loudly.com</Link>
              </Trans>
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="body1">
              {t('legal:terms:sections:18:paragraphs:4')}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="body1">
              {t('legal:terms:sections:18:paragraphs:5')}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="body1">
              {t('legal:terms:sections:18:paragraphs:6')}
            </Typography>
          </ListItem>
        </List>
      </Box>
    </Container>
  );
};

export default TermsOfUse;
